import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import { getTypeName, formatViews } from "@/utils/videoFilters";

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block w-full cursor-pointer animate-fade-up"
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={video.poster}
          alt={`${video.title}封面`}
          title={`${video.title} - 99视频高清影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent opacity-90"></div>

        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md text-[11px] font-medium bg-primary-600/90 text-background-50 backdrop-blur-sm">
          {getTypeName(video.type)}
        </span>
        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded-md text-[11px] font-semibold bg-accent-500 text-accent-950">
          {video.rating.toFixed(1)}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-2 text-[11px] text-background-200/90 mb-1">
            <span>{video.year}</span>
            <span className="w-1 h-1 rounded-full bg-background-300/70"></span>
            <span>{video.region}</span>
            <span className="w-1 h-1 rounded-full bg-background-300/70"></span>
            <span className="inline-flex items-center gap-0.5">
              <i className="ri-play-circle-line"></i>
              {formatViews(video.views)}
            </span>
          </div>
          <h3 className="text-sm font-semibold text-background-50 line-clamp-2 leading-snug">
            {video.title}
          </h3>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-accent-500/90 text-accent-950 flex items-center justify-center text-2xl backdrop-blur-sm">
            <i className="ri-play-fill"></i>
          </span>
        </div>
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {video.tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-900"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}